import React, { useEffect, useState, useRef } from 'react';
import InvestmentForm from '../components/invest/InvestmentForm';
import InvestmentBenefits from '../components/invest/InvestmentBenefits';
import { useWeb3 } from '../contexts/Web3Context';
import { useUI } from '../contexts/UIContext';
import { ethers } from 'ethers';

const Invest = () => {
  const { grichInvContract, isConnected, makeInvestment } = useWeb3();
  const { showLoading, hideLoading, showModal } = useUI();
  const [minDeposit, setMinDeposit] = useState('6');
  const [tokenPrice, setTokenPrice] = useState('0.1');
  const [topupWallet, setTopupWallet] = useState('0');
  const [referrerId, setReferrerId] = useState('');
  
  // Reference to the investment form to reset it
  const investmentFormRef = useRef(null);

  // Get minimum deposit and token price
  useEffect(() => {
    if (grichInvContract) {
      loadContractData();
    }
    
    // Check for referrer ID in localStorage that might have been stored from URL
    const storedReferrerId = localStorage.getItem('referrerId');
    if (storedReferrerId) {
      setReferrerId(storedReferrerId);
    }
  }, [grichInvContract]);

  const loadContractData = async () => {
    try {
      showLoading('Loading contract data...');
      
      // Get minimum deposit
      const minDepositResponse = await grichInvContract.minDeposit();
      setMinDeposit(ethers.utils.formatUnits(minDepositResponse, 18));
      
      // Get token price
      const priceResponse = await grichInvContract.price();
      setTokenPrice(ethers.utils.formatUnits(priceResponse, 18));
      
      hideLoading();
    } catch (error) {
      console.error('Error loading contract data:', error);
      hideLoading();
      showModal('Error', 'Failed to load contract data. Please refresh the page.');
    }
  };

  // Handle investment form submission
  const handleInvestment = async (amount, referrerId, useTopupWallet) => {
    if (!isConnected) {
      showModal('Not Connected', 'Please connect your wallet to make an investment.');
      return;
    }
    
    try {
      const success = await makeInvestment(amount, referrerId, useTopupWallet);
      if (success) {
        // Show success popup
        showModal(
          'Investment Successful', 
          `Your investment of ${amount} USDT has been processed successfully! You've received token cashback in your wallet.`
        );
        
        // Reset the form
        if (investmentFormRef.current) {
          investmentFormRef.current.resetForm();
        }
        
        // Clear stored referrer ID after successful investment
        localStorage.removeItem('referrerId');
      }
    } catch (error) {
      console.error('Investment error:', error);
    }
  };

  return (
    <>
      <h1>Invest in <span className="highlight">GrichInv</span></h1>
      <p className="section-description">Start your journey to financial freedom with our AI-powered investment platform</p>
      
      <div className="investment-container">
        <InvestmentForm 
          ref={investmentFormRef}
          minDeposit={minDeposit}
          tokenPrice={tokenPrice}
          topupWallet={topupWallet}
          initialReferrerId={referrerId}
          onInvest={handleInvestment}
        />
        <InvestmentBenefits />
      </div>
    </>
  );
};

export default Invest;